/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuthorizationOAuthAppsSpec { 
    /**
     * Account type in which OAuth app credentials are saved (SHADOW/ADMIN).
     */
    account_category?: string;
    /**
     * Description of the OAuth app created in CSP.
     */
    app_description?: string;
    /**
     * Id of the OAuth app created in CSP.
     */
    app_id?: string;
    /**
     * Name of the OAuth app created in CSP.
     */
    app_name?: string;
    /**
     * The type of authorization OAuth app (VCF/VMC).
     */
    app_type?: string;
    /**
     * Email of user who authorised the app.
     */
    created_by?: string;
    /**
     * Timestamp (in UTC) when OAuth app was created/authorised.
     */
    created_timestamp?: Date;
    /**
     * Organisation Id for which the OAuth app is created.
     */
    oauth_app_org_id?: string;
    /**
     * VCDS Organisation Id.
     */
    org_id?: string;
    /**
     * AWS secrets manager path where OAuth app credentials are saved.
     */
    sm_path?: string;
    /**
     * VCDS service type value.
     */
    vcds_service_type?: string;
}

